import React from 'react';
import { getAccessChipClassName } from './accessChipColors';
import {
  AccessChip,
  PermissionDescription,
  PermissionListBox,
  PermissionName,
  PermissionRow,
} from './styles';
import { IdentityPermission } from './types';

interface PermissionListProps {
  permissions: IdentityPermission[];
}

interface PermissionItemProps {
  permission: IdentityPermission;
}

function PermissionItem({ permission }: PermissionItemProps) {
  return (
    <PermissionRow>
      <PermissionName>{permission.permissionName}</PermissionName>
      <PermissionDescription>{permission.description}</PermissionDescription>
      <AccessChip
        className={getAccessChipClassName(permission.access)}
        label={permission.access}
        size="small"
      />
    </PermissionRow>
  );
}

export function PermissionList({ permissions }: PermissionListProps) {
  return (
    <PermissionListBox>
      {permissions.map(permission => (
        <PermissionItem
          key={permission.permissionName}
          permission={permission}
        />
      ))}
    </PermissionListBox>
  );
}
